module.exports = __webpack_public_path__ + "img/article3.618baeef.jpg";